
import { Item } from "@/types";
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    item: {
      type: Object as () => Item,
      required: true,
    },
  },
  emits: ["exit"],
  data() {
    return {
      active: true,
      colouredBoxBgColours: [
        "",
        "#72778b",
        "#339c73",
        "#5181cd",
        "#a155df",
        "#be692e",
      ],
      bodyBoxBgColours: [
        [],
        ["#505865", "#545a66", "#828e99"],
        ["#46565c", "#485d60", "#659973"],
        ["#525376", "#4e5d7c", "#489fb3"],
        ["#595482", "#716196", "#b684c8"],
        ["#695352", "#99694e", "#e3ad52"],
      ],
    };
  },
  computed: {
    cssBox(): { [name: string]: string } {
      return {
        "--header-bg-color": this.colouredBoxBgColours[this.item.rarity],
        "--body-bg-gradient-start": this.bodyBoxBgColours[this.item.rarity][0],
        "--body-bg-gradient-middle": this.bodyBoxBgColours[this.item.rarity][1],
        "--body-bg-gradient-end": this.bodyBoxBgColours[this.item.rarity][2],
      };
    },
  },
  methods: {
    exitOutsideCheck(e: Event) {
      if (e.target === document.getElementById("item-description-overlay-bg")) {
        (this.$refs.audioDescriptionOverlayExit as HTMLAudioElement).play();
        this.active = false;
      }
    },
    exit() {
      if (!this.active) {
        this.$emit("exit");
      }
    },
  },
});
